import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Prview_report = () => {
   useAuthRedirect();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);


  const branch = localStorage.getItem("branch");

  const canView  = hasPermission("Prior Purchase Requisition Report", "view");

  useEffect(() => {
    fetchData();
  }, [selectedMonth, selectedYear, approvalStatus]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/prViewApproval_report", {
        params: { 
          month: selectedMonth, 
          year: selectedYear, 
          branch, 
          approvalStatus 
        }
      });

      setData(response.data.prApproval);
      setFilteredData(response.data.prApproval);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) =>
      String(item.prHeader_number || "").toLowerCase().includes(term) ||
      String(item.prDetail_supplierCode || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
  };

  // Pagination Logic
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          
          <h2 className="add-txt">Prior Purchase Requisition</h2>
          <Time />
        </section>

        {/* Approval Status Dropdown */}
        <div className="month-year-container">
          <div className="select-container">
            <select 
              className="custom-select" 
              value={approvalStatus} 
              onChange={(e) => setApprovalStatus(e.target.value)}
            >
              <option value="">-- Select Approval --</option>
              <option value="Y">Approved</option>
              <option value="N">Disapproved</option>
            </select>
          </div>
        

        {/* Month & Year Selection */}
        <p className="title">Select Month & Year:</p>
        <div className="select-container">
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
            className="custom-select"
          >
            {[...Array(12).keys()].map(i => (
              <option key={i + 1} value={i + 1}>
                {(i + 1).toString().padStart(2, "0")}
              </option>
            ))}
          </select>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
            className="custom-select"
          >
            {[...Array(currentYear - startYear + 1).keys()].map(i => (
              <option key={startYear + i} value={startYear + i}>
                {startYear + i}
              </option>
            ))}
          </select>
            
        </div>

        <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/inventory/prview_report';
  }}
>
  View All
</button>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by PR No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Data Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Prior PR No</th>
                <th>Date</th>
                <th>Supplier Code</th>
                <th>Approval Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/prViewSinglereport/${item.prHeader_number}`}>
                        {item.prHeader_number}
                      </Link>
                    </td>
                    <td>{new Date(item.prHeader_date).toLocaleDateString()}</td>
                    <td>{item.prDetail_supplierCode}</td>
                    <td>
  {item.PrDetail_approvalStatusFinal === "Y"
    ? "Approved"
    : item.PrDetail_approvalStatusFinal === "N"
    ? "Disapproved"
    : "Waiting for Approval"}
</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

              {/* Pagination */}
              <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
            1
          </button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={currentPage === pageNumber ? "active" : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
          >
            Next
          </button>
        </div>

      </div>
    </div>
  );
};

export default Prview_report;
